var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7626 6.96974L15.2929 12.5L9.7626 18.0303L8.70205 16.9697L13.1718 12.5L8.70205 8.03028L9.7626 6.96974Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2322 13.2498L3 13.2498L3 11.75L14.2322 11.75V13.2498Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4V20C21.75 20.9665 20.9665 21.75 20 21.75H12V20.25H20C20.138 20.25 20.25 20.1381 20.25 20V4C20.25 3.86193 20.138 3.75 20 3.75L12 3.75V2.25L20 2.25C20.9665 2.25 21.75 3.0335 21.75 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.2ce7b78a56e288262e07ffbb53e74ee2.svg";
export { ForwardRef as ReactComponent };